export function escape(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
